module.exports = __webpack_public_path__ + "static/media/image14-example.dd6afdc3.jpg";